import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { ISbStoryData } from '@storyblok/js';
import { lastValueFrom } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { InputFieldComponent } from 'src/app/shared-extra/components/input-field/input-field.component';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { ReplacePipe } from 'src/app/shared/pipes/replace.pipe';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-form',
  standalone: true,
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    CommonModule,
    BlockWrapperComponent,
    StoryblokDirective,
    InputFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    LoadingIndicatorComponent,
    ReplacePipe,
    ButtonDirective,
  ],
})
export class FormComponent implements OnChanges {
  private toasts = inject(ToastService);
  private http = inject(HttpClient);

  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() fields: ISbStoryData['content'][];

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('technicalFormId') formId: string;
  @Input() ctaText: string;
  @Input() successToast: string;

  sending = false;

  form = new FormGroup({});
  @ViewChild('ngForm') ngForm: NgForm;

  ngOnChanges() {
    this.form = new FormGroup({});
    this.fields.forEach(field => {
      if (field.component === 'FormField') {
        this.form.addControl(field.label, new FormControl('', Validators.required));
      } else if (field.component === 'FormNameField') {
        this.form.addControl('name', new FormControl('', Validators.required));
      }
    });
  }

  async submit() {
    if (!this.form.valid) return;

    this.sending = true;
    const formData = new FormData();
    formData.append('formID', this.formId);
    formData.append('input_language', 'English (US)');

    this.fields.forEach(field => {
      const value = this.form.value[field.label];
      if (field.component === 'FormField') {
        formData.append(field.technicalFieldName, value);
      } else if (field.component === 'FormNameField') {
        const name = this.form.value['name'].trim().split(' ');
        let firstName: string;
        let lastName: string;
        if (name.length === 1) {
          firstName = name[0];
          lastName = '';
        } else {
          lastName = name.pop();
          firstName = name.join(' ');
        }
        formData.append(field.technicalFieldName + '[first]', firstName);
        formData.append(field.technicalFieldName + '[last]', lastName);
      }
    });

    await lastValueFrom(
      this.http.post('https://submit.jotformeu.com/submit/' + this.formId, formData, { responseType: 'text' })
    );
    this.sending = false;

    this.toasts.add('Message sent!', 'success');

    this.form.reset();
    this.ngForm.resetForm();
  }
}
